import { render, staticRenderFns } from "./UnitAreaItems.vue?vue&type=template&id=89429bb8&scoped=true&"
import script from "./UnitAreaItems.vue?vue&type=script&lang=js&"
export * from "./UnitAreaItems.vue?vue&type=script&lang=js&"
import style0 from "./UnitAreaItems.vue?vue&type=style&index=0&id=89429bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89429bb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
